import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { UserContractorEditing, UserContractor } from 'src/api'
import { Entities } from 'src/enums'
import { useApiInstance } from './useApiInstance'

interface EditUserContractorParams {
  userContractorId: number
  body: UserContractorEditing
}

interface RequestParams {
  options?: Omit<UseMutationOptions<UserContractor, Error, EditUserContractorParams>, 'mutationKey' | 'mutationFn'>
}

export const useEditUserContractorRequest = ({ options }: RequestParams = {}) => {
  const api = useApiInstance()

  return useMutation<UserContractor, Error, EditUserContractorParams>(
    [Entities.UserContractors, 'edit'],
    async ({ userContractorId, body }) => {
      const { data } = await api.v1AdminUsersUsersContractorsUserContractorIdPut(userContractorId, body)
      return data as UserContractor
    },
    { ...options }
  )
}
